/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Og_DescriptionInputs */

const et_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aitame teenusettevõtetel saada kliente prognoositavalt. Keskmiselt 3,4x SEO käibekasv.`)
};

const en_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We help service businesses get clients predictably. On average 3.4x SEO revenue growth.`)
};

/**
* | output |
* | --- |
* | "We help service businesses get clients predictably. On average 3.4x SEO revenue growth." |
*
* @param {Meta_Og_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const meta_og_description = /** @type {((inputs?: Meta_Og_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Og_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_meta_og_description(inputs)
	return en_meta_og_description(inputs)
});